import { renderSlot as _renderSlot, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DataView = _resolveComponent("DataView")!

  return (_ctx.loaded && _ctx.getPropertyBooleanValue(_ctx.DataViewTypeConst.VISIBLE))
    ? (_openBlock(), _createBlock(_component_DataView, {
        key: 0,
        container: _ctx.container,
        value: _ctx.getPropertyValue(_ctx.DataViewTypeConst.VALUE),
        layout: _ctx.getCatalogValue(_ctx.DataViewTypeConst.LAYOUT),
        rows: _ctx.getPropertyNumberValue(_ctx.DataViewTypeConst.ROWS),
        first: _ctx.getPropertyNumberValue(_ctx.DataViewTypeConst.FIRST),
        totalRecords: _ctx.getPropertyNumberValue(_ctx.DataViewTypeConst.TOTALRECORDS),
        paginator: _ctx.getPropertyBooleanValue(_ctx.DataViewTypeConst.PAGINATOR),
        paginatorPosition: _ctx.getCatalogValue(_ctx.DataViewTypeConst.PAGINATORPOSITION),
        alwaysShowPaginator: _ctx.getPropertyBooleanValue(_ctx.DataViewTypeConst.ALWAYSSHOWPAGINATOR),
        paginatorTemplate: _ctx.getPropertyValue(_ctx.DataViewTypeConst.PAGINATORTEMPLATE),
        pageLinkSize: _ctx.getPropertyNumberValue(_ctx.DataViewTypeConst.PAGELINKSIZE),
        rowsPerPageOptions: _ctx.getPropertyNumberValue(_ctx.DataViewTypeConst.ROWSPERPAGEOPTIONS),
        currentPageReportTemplate: _ctx.getPropertyValue(_ctx.DataViewTypeConst.CURRENTPAGEREPORTTEMPLATE),
        sortField: _ctx.getPropertyValue(_ctx.DataViewTypeConst.SORTFIELD),
        sortOrder: _ctx.getPropertyNumberValue(_ctx.DataViewTypeConst.SORTORDER),
        lazy: _ctx.getPropertyBooleanValue(_ctx.DataViewTypeConst.LAZY),
        dataKey: _ctx.getPropertyValue(_ctx.DataViewTypeConst.DATAKEY),
        pt: _ctx.getPropertyValue(_ctx.DataViewTypeConst.PT),
        unstyled: _ctx.getPropertyBooleanValue(_ctx.DataViewTypeConst.UNSTYLED)
      }, {
        list: _withCtx((slotProps) => [
          _renderSlot(_ctx.$slots, "list", {
            slotProps: { data: slotProps.data, index: slotProps.index, control: _ctx.ControlTypeConst.CTDATAVIEW }
          })
        ]),
        header: _withCtx(() => [
          _renderSlot(_ctx.$slots, "header")
        ]),
        footer: _withCtx(() => [
          _renderSlot(_ctx.$slots, "footer")
        ]),
        paginatorstart: _withCtx(() => [
          _renderSlot(_ctx.$slots, "paginatorstart")
        ]),
        paginatorend: _withCtx(() => [
          _renderSlot(_ctx.$slots, "paginatorend")
        ]),
        empty: _withCtx(() => [
          _renderSlot(_ctx.$slots, "empty")
        ]),
        grid: _withCtx((slotProps) => [
          _renderSlot(_ctx.$slots, "grid", {
            slotProps: { data: slotProps.data, index: slotProps.index, control: _ctx.ControlTypeConst.CTDATAVIEW }
          })
        ]),
        _: 3 /* FORWARDED */
      }, 8 /* PROPS */, ["container", "value", "layout", "rows", "first", "totalRecords", "paginator", "paginatorPosition", "alwaysShowPaginator", "paginatorTemplate", "pageLinkSize", "rowsPerPageOptions", "currentPageReportTemplate", "sortField", "sortOrder", "lazy", "dataKey", "pt", "unstyled"]))
    : _createCommentVNode("v-if", true)
}